export default {
  namespaced: true,

  state: {
    selectedSpace: {},
    currentSpaceOrigin: "",
    isPanelCollapsed: false,
  },

  mutations: {
    SET_SELECTED_SPACE(state, value) {
      state.selectedSpace = value;
    },

    SET_CURRENT_SPACE_ORIGIN(state, value) {
      state.currentSpaceOrigin = value;
    },

    SET_PANEL_COLLAPSED(state, collapsed) {
      state.isPanelCollapsed = collapsed;
    },
  },

  actions: {
    setSelectedSpace({ commit }, value) {
      commit("SET_SELECTED_SPACE", value);
      commit("SET_CURRENT_SPACE_ORIGIN", value?.origin);
    },
  },

  getters: {
    selectedSpace: (state) => state.selectedState,
    currentSpaceOrigin: (state) => state.currentSpaceOrigin,
    isPanelCollapsed: (state) => state.isPanelCollapsed,
  },
};
